import { render, staticRenderFns } from "./new-index.vue?vue&type=template&id=5769cfb9&scoped=true"
import script from "./new-index.vue?vue&type=script&lang=js"
export * from "./new-index.vue?vue&type=script&lang=js"
import style0 from "./new-index.vue?vue&type=style&index=0&id=5769cfb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5769cfb9",
  null
  
)

export default component.exports